module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/G2dTB6/tc-custom/9780802199652.jpg?1697126209331",
      "alt": "This image is the cover for the book Landscape of the Body"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Landscape of the Body\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Death, desire, and tabloid sensationalism converge in “this delirious heartbreaker of a comedy” by the Tony Award-winning playwright (Ben Brantley, "), _c('i', [_vm._v("The New York Times")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("Along with "), _c('i', [_vm._v("Six Degrees of Separation")]), _vm._v(" and "), _c('i', [_vm._v("The House of Blue Leaves")]), _vm._v(", Landscape of the Body is one of John Guare’s most celebrated plays. It tells the story of a woman’s unfulfilled life and premature death—and her reflections from the grave. "), _c('br'), _c('br'), _vm._v("Betty Yearn first came to New York City to convince her sister Rosalie to leave the gritty urban world behind and come home to bucolic Maine. But when Rosalie dies in a freak bicycle accident, Betty returns to ease into her sister’s previous persona—moving into her apartment, even taking over her job—as Rosalie watches from the beyond. Then Betty’s fortunes take a jarring turn. After losing her teenage son to murder, she finds herself the primary suspect in the crime. After all, death does seem to have a way of following in her trail. "), _c('br'), _c('br'), _vm._v("In what Michael Kuchwara of the Associated Press called “his most surreal and haunting play,” John Guare brilliantly moves back and forth in time and space to create an affecting study of the American dream gone awry.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Guare\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grove Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0